module.exports = __webpack_public_path__ + "66b5466118c26cef4aad867b26839b2b.png";